import {useEffect, useMemo, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import useBodyClass from '../../common/hooks/useBodyClassName';
import { hideLoader, showLoader } from '../../store/common/slice';
import { StyledMaintenanceWrapper } from './Maintenance.styled';
import ErrorsHandler from "../../common/errors/handleErrors";
import {maintenanceLogin} from "../../store/manager/actions";
import {partnerMaintenanceTitlesTranslations} from "../sidebar/partnerMaintenanceTitlesTranslations";


const BASE_LIVY_URL = 'https://www.livy.co.il';
const BASE_IFRAME_URL = `${BASE_LIVY_URL}/embedded/`;

// this is a POC to integrate with a 3rd party (livy.co.il) maintainace platform
const Maintenance = ({ match }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const titleData = useSelector(state => state.buildings.titleData);

    const { entityType, entityValue, pageName } = match.params;

    useBodyClass('report');

    const [loaded, setLoaded] = useState(false);
    const livyIframeToken = useSelector(state => state.manager.livyIframeToken);

    useEffect(() => {
        if (!livyIframeToken.pending && livyIframeToken.data == null && livyIframeToken.error == null) {
            if (entityType === 'partner') {
                dispatch(maintenanceLogin({ partnerID: entityValue }));
            } else if (entityType === 'building') {
                dispatch(maintenanceLogin({ buildingID: entityValue }));
            }

        } else if (livyIframeToken.error != null) {
            ErrorsHandler.notifyClientError(livyIframeToken.error);
            setLoaded(true);
        } else if (livyIframeToken.data != null) {
            setLoaded(true);
        }
    }, [livyIframeToken]);

    useEffect(() => dispatch(livyIframeToken.pending ? showLoader() : hideLoader()), [livyIframeToken]);

    const isMobile = useMemo(() => window.mobileCheck(), []);

    const pageUrl = useMemo(() => {
        let pageUrl
        if (livyIframeToken?.data){
            pageUrl = `${BASE_IFRAME_URL}${livyIframeToken.data}`
            const mobileAdd = isMobile ? 'mobile=1' : 'mobile=0';
            // https://bllink.atlassian.net/browse/SSB-1169 hiding navigation to other buildings
            // in case of single building context
            const isBuildingContext = entityType === 'building';
            const hideDropDown = isBuildingContext ? 'mode=100': '';
            if (pageName === 'maintenanceManager'){
                // todo this is deprecated page. can delete this if after 1/11/2023
                pageUrl += '/all?' + mobileAdd
            }
            else{
                // https://bllink.atlassian.net/browse/SSB-1169
                if (!hideDropDown){
                    pageUrl += '/all'
                }
                pageUrl += `?page=${pageName}&${mobileAdd}&${hideDropDown}`
            }
        }

        return pageUrl
    }, [isMobile, pageName, livyIframeToken])

    return (
        <StyledMaintenanceWrapper>
            <h1 className='page-title text-only'>
                {t(partnerMaintenanceTitlesTranslations[pageName])}
            </h1>

            {livyIframeToken?.data && (
                <iframe id="inlineFrameExample"
                    title="Inline Frame Example"
                    // width="1000"
                    height="1500"
                    src={pageUrl}
                />
            )}

            {loaded && !livyIframeToken?.data && (<h1>no feature set for this building</h1>)}
        </StyledMaintenanceWrapper>
    )
}

export default Maintenance;
